// Copyright 2016 Sorama B.V.

import { autoinject, computedFrom } from "aurelia-framework";
import { RecordingContainer, RecordingMetadata } from "datatypes/Containers";
import { IModal } from "libraries/WorkflowFramework/Interfaces/IModal";
import { MeasurementRepository } from "repositories/MeasurementRepository";
import { ProjectRepository } from "repositories/ProjectRepository";
import { IStorageService } from "services/Storage/IStorageService";

@autoinject
export class RecordingDetailsModal implements IModal<unknown> {
    private isLoading: boolean;
    private isSaving: boolean;
    private errorMessage: string;

    private container: RecordingContainer;
    private containerPath: string;
    private metadata: RecordingMetadata;

    private _name: string;
    private _distance: number;

    @computedFrom("_name")
    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        // Update name in the metadata
        this.storageService.updateMetadata(this.container.id, "name", value).then(() => (this._name = value));
    }

    @computedFrom("_distance")
    public get distance(): number {
        return this._distance;
    }

    public set distance(value: number) {
        this.storageService.updateMetadata(this.container.id, "distance", value).then(() => (this._distance = value));
    }

    constructor(
        private readonly storageService: IStorageService,
        private readonly projectsRepository: ProjectRepository,
        private readonly measurementRepository: MeasurementRepository
    ) {}

    public activateModal(state: RecordingContainer) {
        this.errorMessage = null;
        this.container = state;

        // Load container
        this.isLoading = true;

        // Get the path of the container
        this.storageService
            .getPath(this.container.id)
            .then((path) => {
                this.containerPath = path;
            })
            .then(() => this.storageService.load(this.container.id))
            .then((container) => {
                this.metadata = container.metadata;
                this._name = this.metadata.name;
                this._distance = this.metadata.distance;
                this.isLoading = false;
            })
            .catch((e: Error) => {
                this.errorMessage = e.message;
                this.isLoading = false;
            });
    }

    public deactivate(): unknown {
        return this.container;
    }

    public openContainerPathInExplorer(): void {
        this.storageService.openInExplorer(this.containerPath);
    }
}
